import React from "react";
import * as PopoverPrimitive from "@radix-ui/react-popover";
import { cx } from "class-variance-authority";

import * as styles from "./Popover.module.scss";

const Popover = PopoverPrimitive.Root;
const PopoverTrigger = PopoverPrimitive.Trigger;

const PopoverContent = React.forwardRef<
  React.ElementRef<typeof PopoverPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content> & {
    showArrow?: boolean;
    arrowClassName?: string;
  }
>(
  (
    {
      className,
      arrowClassName,
      align = "center",
      sideOffset = 4,
      children,
      showArrow = false,
      ...props
    },
    ref,
  ) => (
    <PopoverPrimitive.Portal>
      <PopoverPrimitive.Content
        ref={ref}
        align={align}
        sideOffset={sideOffset}
        className={cx(styles.popover, className)}
        {...props}
      >
        {children}
        {showArrow && (
          <PopoverPrimitive.Arrow
            className={cx(styles.popoverArrow, arrowClassName)}
          />
        )}
      </PopoverPrimitive.Content>
    </PopoverPrimitive.Portal>
  ),
);
PopoverContent.displayName = PopoverPrimitive.Content.displayName;

const PopoverArrow = PopoverPrimitive.Arrow;

export { Popover, PopoverTrigger, PopoverContent, PopoverArrow };
